<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 위험물시설 -->
    <write-grid-container v-model="form.subInfo" :options="gridContainerOptions">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input" v-if="dataType === 'date'">{{ form.subInfo[value] }}</div>
          <div class="print-input" v-else>{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector v-if="dataType === 'date'" class="w-full" v-model="form.subInfo[value]" />
          <ml-input v-else-if="dataType === 'number'" class="w-full" type="number" v-model="form.subInfo[value]" :min-value="0" />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" />
        </div>
      </template>
    </write-grid-container>

    <div>
      <div class="my-4 flex">
        <h5 class="title"><i class="dot"></i>관련법령</h5>
      </div>
      <vs-row class="mt-28px">
        <vs-col class="w-full" vs-align="center">
          <div class="grid grid-cols-12 gap-4">
            <div v-for="item in lawList" :key="`lawList_${item.label}`" class="col-span-12 sm:col-span-6 xl:col-span-4 w-full flex items-center">
              <vs-checkbox class="m-0 grid" style="grid-template-columns: auto 1fr" :disabled="board.readonly" v-model="form.inputC_1" :vs-value="item.label">{{ item.label }}</vs-checkbox>
              <a :href="item.url" alt="url" target="_blank">
                <feather-icon icon="ExternalLinkIcon" class="ml-2" style="color: #7e72f2" />
              </a>
            </div>
            <!-- 사용자 추가 항목들 -->
            <div v-for="(customItem, idx) in form.customLawItems" :key="`custom_${idx}`" class="col-span-12 sm:col-span-6 xl:col-span-4 w-full flex items-center">
              <vs-checkbox class="m-0 grid" style="grid-template-columns: auto 1fr" :disabled="board.readonly" v-model="form.inputC_1" :vs-value="customItem.text">{{ customItem.text || "(미입력)" }}</vs-checkbox>
              <a v-if="customItem.link" :href="customItem.link" alt="url" target="_blank">
                <feather-icon icon="ExternalLinkIcon" class="ml-2" style="color: #7e72f2" />
              </a>
              <feather-icon v-if="!board.readonly" icon="EditIcon" class="ml-2 cursor-pointer" style="color: #7e72f2" @click="editCustomItem(idx)" />
              <feather-icon v-if="!board.readonly" icon="XIcon" class="ml-1 cursor-pointer" style="color: #ea5455" @click="removeCustomItem(idx)" />
            </div>
            <!-- 항목 추가 버튼 -->
            <div v-if="!board.readonly" class="col-span-12 sm:col-span-6 xl:col-span-4 flex items-center">
              <vs-button class="p-2" type="border" icon="add" @click="addCustomItem">항목 추가</vs-button>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </div>

    <!--    -->

    <!--    파일첨부-->
    <file-upload-module id="fileList" title="법규등록부 첨부" class="w-full mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <!-- 사용자 정의 항목 추가/수정 팝업 -->
    <vs-popup class="custom-item-popup" title="법령 항목 추가" :active.sync="showCustomItemPopup">
      <div class="popup-content">
        <div class="input-group mb-4">
          <label class="block mb-2 font-medium">법령명 *</label>
          <vs-input class="w-full" v-model="tempCustomItem.text" placeholder="법령명을 입력하세요" />
        </div>
        <div class="input-group">
          <label class="block mb-2 font-medium">링크 (URL)</label>
          <vs-input class="w-full" v-model="tempCustomItem.link" placeholder="https://example.com" />
        </div>
      </div>
      <div class="popup-footer flex justify-end gap-2 pt-4 border-t mt-4">
        <vs-button type="border" @click="cancelCustomItem">취소</vs-button>
        <vs-button @click="saveCustomItem">저장</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import FileDownloadPost from "@/components/FileDownloadPost.vue";

export default {
  components: {
    FileDownloadPost,
    CustomOptionSelector,
    DateSelectorRang,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      isMobile: false,
      result_options1: ["고압가스", "액화석유가스", "도시가스"],
      result_options2: ["제조", "취급", "저장"],
      gridContainerOptions: {
        dataTypes: ["date", "string"],
        labels: ["제·개정일자", "제·개정번호"],
        values: ["개정일자", "개정번호"],
      },
      lawList: [
        {
          label: "기후위기 대응을 위한 탄소중립·녹색성장 기본법",
          url: "https://www.law.go.kr/lsInfoP.do?lsiSeq=247503&lsId=014152&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#",
        },
        {
          label: "온실가스 배출권의 할당 및 거래에 관한 법률",
          url: "https://www.law.go.kr/lsInfoP.do?lsiSeq=259559&lsId=011612&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#",
        },
        {
          label: "에너지법",
          url: "https://www.law.go.kr/lsInfoP.do?lsiSeq=245517&lsId=010281&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#",
        },
        {
          label: "에너지이용합리화법",
          url: "https://www.law.go.kr/lsInfoP.do?lsiSeq=244975&lsId=001867&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#",
        },
        {
          label: "기계설비법",
          url: "https://www.law.go.kr/lsInfoP.do?lsiSeq=219239&lsId=013114&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#",
        },
      ],

      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},

        inputB_1: "",
        inputC_1: [],
        inputC_1_1: { text: "", link: "" },
        customLawItems: [], // 사용자 추가 항목 배열 [{ text: '', link: '' }, ...]
        법령명: "",
      },
      // 항목 추가/수정 팝업용
      showCustomItemPopup: false,
      editingCustomItemIndex: -1,
      tempCustomItem: { text: "", link: "" },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            if (key === "inputC_1" && typeof value[key] === "string") {
              this.form[key] = [value[key]];
              continue;
            }
            this.form[key] = value[key];
          }
        }
        // 기존 inputC_1_1 데이터가 있고 customLawItems가 비어있으면 마이그레이션
        this.migrateOldData();
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.form.subInfo.개정일 === "") {
          this.form.subInfo.개정일 = new Date().format("yyyy-MM-dd");
        }

        this.$emit("input", value);
      },
    },
    "form.inputC_1": {
      immediate: true,
      deep: true,
      handler(value) {
        // 선택된 법령명들을 배열로 저장
        this.form.법령명 = Array.isArray(value) ? value : [value];
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
    // mobile 체크
    this.checkMobile();
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    // 기존 inputC_1_1 데이터를 customLawItems로 마이그레이션
    migrateOldData() {
      const oldData = this.form.inputC_1_1;
      // 기존 데이터가 있고, customLawItems에 아직 없으면 추가
      if (oldData && oldData.text && oldData.text.trim()) {
        const exists = this.form.customLawItems.some((item) => item.text === oldData.text);
        if (!exists) {
          this.form.customLawItems.push({ text: oldData.text, link: oldData.link || "" });
          // "직접입력" 체크를 실제 텍스트로 변경
          const directInputIndex = this.form.inputC_1.indexOf("직접입력");
          if (directInputIndex > -1) {
            this.$set(this.form.inputC_1, directInputIndex, oldData.text);
          }
        }
      }
    },
    // 사용자 정의 항목 추가
    addCustomItem() {
      this.editingCustomItemIndex = -1;
      this.tempCustomItem = { text: "", link: "" };
      this.showCustomItemPopup = true;
    },
    // 사용자 정의 항목 수정
    editCustomItem(index) {
      this.editingCustomItemIndex = index;
      this.tempCustomItem = { ...this.form.customLawItems[index] };
      this.showCustomItemPopup = true;
    },
    // 사용자 정의 항목 삭제
    removeCustomItem(index) {
      const item = this.form.customLawItems[index];
      // 체크된 상태라면 inputC_1에서도 제거
      const checkedIndex = this.form.inputC_1.indexOf(item.text);
      if (checkedIndex > -1) {
        this.form.inputC_1.splice(checkedIndex, 1);
      }
      this.form.customLawItems.splice(index, 1);
    },
    // 팝업 저장
    saveCustomItem() {
      if (!this.tempCustomItem.text.trim()) {
        this.$vs.notify({
          title: "알림",
          text: "텍스트를 입력해주세요.",
          color: "warning",
        });
        return;
      }
      // 링크에 프로토콜 추가
      let link = this.tempCustomItem.link;
      if (link && !link.includes("http://") && !link.includes("https://")) {
        link = "https://" + link;
      }
      const newItem = { text: this.tempCustomItem.text.trim(), link };

      if (this.editingCustomItemIndex === -1) {
        // 새 항목 추가
        this.form.customLawItems.push(newItem);
      } else {
        // 기존 항목 수정
        const oldText = this.form.customLawItems[this.editingCustomItemIndex].text;
        // 체크된 상태였다면 새 텍스트로 업데이트
        const checkedIndex = this.form.inputC_1.indexOf(oldText);
        if (checkedIndex > -1) {
          this.$set(this.form.inputC_1, checkedIndex, newItem.text);
        }
        this.$set(this.form.customLawItems, this.editingCustomItemIndex, newItem);
      }
      this.showCustomItemPopup = false;
    },
    // 팝업 취소
    cancelCustomItem() {
      this.showCustomItemPopup = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-item-popup {
  .popup-content {
    padding: 1rem 0;
  }
  .popup-footer {
    border-top: 1px solid #eee;
  }
}
</style>
